import * as React from "react";
import { Redirect } from "react-router-dom";
import Modal from "react-awesome-modal";

import withServices from "../../../HOCs/withServices";
import NavBar from "../../../components/CustomNav/CustomNav.Component";
import amex from "../../../assets/images/cardicons/amex.png";
import discovercard from "../../../assets/images/cardicons/discovercard.png";
import mastercard from "../../../assets/images/cardicons/mastercard.png";
import visa from "../../../assets/images/cardicons/visa.png";
import plexsymbol from "../../../assets/images/plex_symbol.png";
import {
  StyledRow,
  CheckoutSummary,
  PaymentModalRow,
} from "./PrePayment.styles";

import { Container } from "../../Onboard/Common/Common.styles";
import {
  Section,
  Heading,
  Col2,
  Row,
} from "../../Onboard/Parent/Registration/ParentRegistration.styles";
import CheckoutForm from "../../Subscription/StripeCheckoutForm/StripeCheckoutForm.Component";
import Package from "../../../components/PaymentPackage/PaymentPackage";
import "font-awesome/css/font-awesome.min.css";
import { Elements, StripeProvider } from "react-stripe-elements";
import {
  FormWrapper,
  InputWrapper,
  TooltipParagraph,
  ModalContainer,
  FeedbackP,
  InputItemsRow,
  PackagesWrapper,
} from "../Common/Common.styles";
import schoolBg from "../../../assets/images/parentreg/schoolbg.jpg";
import parentBg from "../../../assets/images/parentreg/parentreg-bg.jpg";

import { toast } from "react-toastify";

import { setSubscriptionData } from "../../../common/services";

interface IProps {
  services?: any;
  history?: any;
  match?: any;
  isSchool: boolean;
}

const vimeoVar1 = "why_plex_1";
const vimeoVar2 = "why_plex_2";
class PrePaymentPage extends React.Component<IProps, any> {
  private packagesRef = React.createRef<HTMLDivElement>();

  constructor(props) {
    super(props);

    this.state = {
      navigate: false,
      destination: "",
      showCheckout: false,
      amount: 0,
      firstName: "",
      lastName: "",
      toLogin: false,
      packages: [],
      coupon: "",
      packagesLoaded: false,
      selectedPackage: null,
      paymentSuccess: false,
      feedbackOpen: false,
      vimeoID1: null,
      vimeoID2: null,
      vimeoLoaded: false,
      currentPlanType: "MONTHLY",
      planID: null,
      payLoaded: false,
      planName: "",
      planPrice: 0,
      finalPrice: 0,
      couponValue: 0, // this is a percentage
      couponValid: false,
      couponChecked: false,
    };

    this.onLogout = this.onLogout.bind(this);
    this.checkout = this.checkout.bind(this);
    this.submitPaymentDetailsHandler =
      this.submitPaymentDetailsHandler.bind(this);
    this.checkCoupon = this.checkCoupon.bind(this);
  }

  public async componentDidMount() {
    const {
      services: {
        adminAPI,
        currentBaseUrl,
        isUserLoggedIn,
        isUserUpgraded,
        hasActiveSubscription,
      },
      history,
    } = this.props;
    if (!isUserLoggedIn) {
      this.setState({ toLogin: true });
    }

    if (hasActiveSubscription && isUserUpgraded) {
      // user has an active package
      history.replace(`${currentBaseUrl}home`);
    } else {
      const [packagesRes, vimeo1, vimeo2] = await Promise.all([
        adminAPI.getPackagesList(),
        adminAPI.fetchVimeoSystemVar(vimeoVar1),
        adminAPI.fetchVimeoSystemVar(vimeoVar2),
      ]);
      console.log("props: ", this.props);
      const packageID = this.props.match.params.pkid;
      console.log(packageID);
      if (packagesRes.ok) {
        const allPackages = packagesRes.data.packages;
        const vimeoID1 = vimeo1.data.value;
        const vimeoID2 = vimeo2.data.value;
        let packages = new Array();
        if (typeof packageID === "undefined") {
          packages = allPackages;
        } else {
          const selectedPk = allPackages.find(
            (item) => item.PackageId === +packageID
          );
          packages.push(selectedPk);
        }
        this.setState({
          packages,
          packagesLoaded: true,
          vimeoID1,
          vimeoID2,
          vimeoLoaded: true,
        });
      }
    }
  }

  public onLogout() {
    this.setState({ navigate: true, destination: "/login" });
  }

  // checkoutform methods
  public togglePaymentState() {
    // to come
  }

  public async checkCoupon(e) {
    // check coupon validity
    const {
      services: { adminAPI },
    } = this.props;
    const { coupon, planPrice, selectedPackage } = this.state;
    if (coupon !== "") {
      const couponRes = await adminAPI.checkCoupon(
        coupon.trim(),
        selectedPackage
      );
      if (couponRes.ok) {
        const couponValue = couponRes.data.coupon.PercentOff;
        const finalPrice = +planPrice - (+planPrice * couponValue) / 100;
        this.setState({
          couponValid: true,
          couponChecked: true,
          finalPrice,
          couponValue,
        });
      } else {
        this.setState({ couponValid: false, couponChecked: true });
      }
    } else {
      return;
    }
  }
  public couponFocusHandler = () => {
    this.setState({ couponChecked: false });
  };

  public checkout(pk, planName, planID, planPrice, currentPlanType) {
    this.setState({
      selectedPackage: pk,
      planID,
      planName,
      planPrice,
      finalPrice: planPrice,
      showCheckout: true,
      currentPlanType,
    });
  }

  public closeCheckoutModal = () => {
    this.setState({ showCheckout: false, selectedPackage: null });
  };

  public async submitPaymentDetailsHandler(token) {
    // trigger on stripe success
    const {
      coupon,
      firstName,
      lastName,
      selectedPackage,
      currentPlanType,
      packages,
    } = this.state;

    const {
      services: { parentsAPI, institutionsAPI },
    } = this.props;
    const currentPackage = packages.find(
      (p) => p.PackageId === selectedPackage
    );
    const currentPlan = currentPackage.Plans[0];

    if (!token) {
      toast.error("Error! Could not process card!");
      return;
    }
    const payload = {
      data: {
        coupon: coupon.trim(),
        firstName,
        lastName,
        payment_method_id: token,
        pk: selectedPackage,
        plan_id: currentPlan.id,
        plan_type: currentPlan.type,
        quantity: 1,
      },
    };

    let cardSuccess;
    if (this.props.isSchool) {
      cardSuccess = await institutionsAPI.makePayment(payload);
    } else {
      cardSuccess = await parentsAPI.makePayment(payload);
    }

    if (cardSuccess.ok) {
      this.setState({
        paymentSuccess: true,
        payLoaded: true,
        feedbackOpen: true,
      });
      this.closeCheckoutModal();
      // fetcch user info and update subscription in session storage
      const userInfoRes = await this.props.services.adminAPI.fetchUserInfo();
      if (userInfoRes.ok) {
        const subscription = userInfoRes.data.subscription;
        setSubscriptionData(subscription);
      }
    } else {
      this.setState({
        paymentSuccess: false,
        payLoaded: true,
        feedbackOpen: true,
      });

      setTimeout(() => this.closeModal(false), 5000);
    }
  }

  public isSignupFilled = () => {
    if (this.state.firstName.length < 1 || this.state.lastName.length < 1) {
      toast.warn("Please fill all the fields!");
      return false;
    } else {
      return true;
    }
  };

  public StartProcessing() {
    // start processing stripe
    // may not be useful
  }

  public handleChange = (event) => {
    const valname = event.currentTarget.dataset.arg;
    this.setState({ [valname]: event.target.value });
  };
  public closeModal = (status) => {
    const {
      services: { currentBaseUrl },
    } = this.props;
    if (status === true) {
      // sign up was successful, go to login
      this.props.history.push(currentBaseUrl + "assessmentguide");
    }
    this.setState({ feedbackOpen: false });
  };

  public togglePlanType = () => {
    const { currentPlanType } = this.state;
    if (currentPlanType === "MONTHLY") {
      this.setState({ currentPlanType: "YEARLY" });
    }
    if (currentPlanType === "YEARLY") {
      this.setState({ currentPlanType: "MONTHLY" });
    }
  };

  public renderCouponInfo = () => {
    const { couponChecked, couponValid, couponValue, finalPrice } = this.state;
    if (couponChecked) {
      return couponValid ? (
        <p style={{ color: "#acff24" }}>
          <i className="fa fa-check" /> It worked! You get your first assessment
          for just &pound;{finalPrice !== null ? finalPrice.toFixed(2) : ""}
        </p>
      ) : (
        <p style={{ color: "#ff0033" }}>
          <i className="fa fa-exclamation-circle" /> Coupon Invalid!
        </p>
      );
    } else {
      return "";
    }
  };

  public renderPackages = () => {
    const { packages, packagesLoaded, currentPlanType } = this.state;
    if (packagesLoaded) {
      return (
        <React.Fragment>
          <StyledRow showBg={false} show={true}>
            <Heading
              style={{ margin: "1em 0 0 0" }}
              width="100%"
              color="#000"
              fontSize="48px"
            >
              WELCOME TO PERFORMANCE LEARNING!
            </Heading>

            {packages.length > 1 ? (
              <PackagesWrapper>
                {packages
                  .filter((item) => item.Name === "Foresight Assessment Only")
                  .map((item, i) => {
                    const currentPlan = item.Plans.length
                      ? item.Plans[0]
                      : { price: 0, type: "MONTHLY" };
                    return (
                      <Package
                        key={`package${item.PackageId}`}
                        name={item.Name}
                        description={item.Description}
                        price={currentPlan.price}
                        period={currentPlan.type}
                        color={i % 2 ? "#3ee9f7" : "#acff24"}
                        features={item.Benefits.listing}
                        onPackageSelect={this.checkout.bind(
                          this,
                          item.PackageId,
                          item.Name,
                          currentPlan.id,
                          currentPlan.price,
                          currentPlan.type
                        )}
                        buttonText="GET MY CHILD'S ASSESSMENT"
                      />
                    );
                  })}
              </PackagesWrapper>
            ) : (
              <Row
                style={{
                  maxWidth: "960px",
                  boxShadow: "10px 10px 64px #0a0a0a",
                }}
                wrap={true}
                width="80%"
                justify="center"
              >
                <Col2
                  height="650px"
                  background={this.props.isSchool ? schoolBg : parentBg}
                >
                  <div
                    style={{
                      height: "100%",
                      width: "100%",
                      backgroundColor: "rgba(0,0,0,.2)",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-start",
                      justifyContent: "flex-end",
                      padding: "2em",
                      minWidth: "400px",
                    }}
                  >
                    {/* <Heading style={{ textAlign: "left" }}>
                  It's time for you to register.
                </Heading> */}
                  </div>
                </Col2>
                <Col2 height="650px">
                  {packages.map((item, i) => {
                    const currentPlan = item.Plans.length
                      ? item.Plans[0]
                      : { price: 0, type: "MONTHLY" };
                    return (
                      <Package
                        key={`package${item.PackageId}`}
                        name={item.Name}
                        description={item.Description}
                        price={currentPlan.price}
                        period={currentPlan.type}
                        color={i % 2 ? "#3ee9f7" : "#acff24"}
                        features={item.Benefits.listing}
                        onPackageSelect={this.checkout.bind(
                          this,
                          item.PackageId,
                          item.Name,
                          currentPlan.id,
                          currentPlan.price,
                          currentPlan.type
                        )}
                      />
                    );
                  })}
                </Col2>
              </Row>
            )}
          </StyledRow>
        </React.Fragment>
      );
    } else {
      console.log("Packages Loading...");
      return;
    }
  };

  public renderFeedbackModal = () => {
    const { feedbackOpen, paymentSuccess, payLoaded } = this.state;
    if (feedbackOpen) {
      let content = (
        <React.Fragment>
          <FeedbackP success={paymentSuccess}>
            <span>Payment Successful! </span>
            <br />
          </FeedbackP>
          <p style={{ fontSize: "14px", textAlign: "center", width: "100%", padding: "0 1em" }}>
            As a first step you'll be asked to complete the parent Foresight
            questions, these ask you about your child. Once completed you can
            activate Foresight for your child.
          </p>
          <button
            style={{ padding: ".5em 1em" }}
            className="payment-success green-button"
            onClick={this.closeModal.bind(this, true)}
          >
            Ready to go
          </button>
        </React.Fragment>
      );
      if (!paymentSuccess) {
        content = (
          <FeedbackP success={paymentSuccess}>
            <span>Payment Failed! </span>
            <br /> check your card details and try again!
          </FeedbackP>
        );
      }
      return (
        <Modal
          visible={feedbackOpen}
          effect="fadeInUp"
          onClickAway={this.closeModal.bind(this, paymentSuccess)}
          width="500"
          height="400"
        >
          <ModalContainer>{content}</ModalContainer>
        </Modal>
      );
    } else {
      console.log("no feedback yet");
      return;
    }
  };

  public renderCheckoutModal = () => {
    const { planName, planPrice, finalPrice, currentPlanType } = this.state;
    return (
      <Modal
        visible={this.state.showCheckout}
        effect="fadeInUp"
        onClickAway={this.closeCheckoutModal}
        width="900"
        height="600"
      >
        <div style={{ backgroundColor: "#1a1a1a" }}>
          <i
            className="fa fa-times-circle-o close-modal"
            aria-hidden="true"
            onClick={this.closeCheckoutModal}
            style={{
              float: "right",
              margin: "20px 20px 0 0",
              fontSize: "32px",
              color: "#acff24",
              cursor: "pointer",
            }}
          />
          <PaymentModalRow>
            <FormWrapper width="70%">
              <form>
                <h2 className="form-header">COMPLETE YOUR PURCHASE</h2>
                <div className="fields-wrapper">
                  <div className="transaction-method">
                    <p className="transaction-card">
                      PLEASE ENTER YOUR CARD DETAILS BELOW
                    </p>
                    <div className="card-icons">
                      <img src={visa} alt="visa icon" title="Visa" />
                      <img
                        src={mastercard}
                        alt="mastercard icon"
                        title="Mastercard"
                      />
                      <img
                        src={amex}
                        alt="amex icon"
                        title="American Express"
                      />
                      <img
                        src={discovercard}
                        alt="discovercard icon"
                        title="Discover Card"
                      />
                    </div>
                  </div>
                  <InputItemsRow>
                    <InputWrapper>
                      <p>First Name</p>
                      <input
                        className="custom-textfield checkout-input"
                        type="text"
                        name="firstName"
                        id="first-name"
                        placeholder="First Name"
                        onChange={this.handleChange}
                        required={true}
                        data-arg="firstName"
                      />
                    </InputWrapper>
                    <InputWrapper>
                      <p>Last Name</p>
                      <input
                        className="custom-textfield checkout-input"
                        type="text"
                        name="lastName"
                        id="last-name"
                        placeholder="Last Name"
                        onChange={this.handleChange}
                        required={true}
                        data-arg="lastName"
                      />
                    </InputWrapper>
                  </InputItemsRow>
                  <InputWrapper>
                    <p>Promo Code</p>
                    <input
                      className="custom-textfield checkout-input"
                      type="text"
                      name="coupon"
                      id="coupon"
                      placeholder="Enter your promo code"
                      onChange={this.handleChange}
                      data-arg="coupon"
                      onBlur={this.checkCoupon}
                      onFocus={this.couponFocusHandler}
                    />
                    {this.renderCouponInfo()}
                  </InputWrapper>
                </div>

                <StripeProvider apiKey={this.props.services.stripeKey}>
                  <div className="stripe-elems">
                    <Elements>
                      <CheckoutForm
                        togglePaymentState={this.togglePaymentState}
                        amount={this.state.amount}
                        onSuccess={this.submitPaymentDetailsHandler}
                        formFilled={this.isSignupFilled}
                        StartProcessing={this.StartProcessing}
                      />
                    </Elements>
                  </div>
                </StripeProvider>
              </form>
            </FormWrapper>
            <div className="modal-right">
              <h2 className="order-header">Your Order</h2>
              <CheckoutSummary>
                <div className="order-name">
                  <img src={plexsymbol} alt="" />
                  <p className="checkout-name">{planName}</p>
                </div>
                <hr />
                <div
                  className="order-details"
                  style={
                    this.state.couponValid
                      ? {
                        textDecoration: "line-through",
                        transform: "scale(0.9)",
                        opacity: 0.5,
                      }
                      : {}
                  }
                >
                  <p className="order-detail">Total Due Today: </p>
                  <p className="order-value">
                    &nbsp;&pound;{planPrice.toFixed(2)}
                  </p>
                </div>
                <div
                  className="order-details"
                  style={{
                    display: `${this.state.couponValid ? "" : "none"}`,
                  }}
                >
                  <p className="order-detail">Total Due Today: </p>
                  <p className="order-value">
                    &nbsp;&pound;
                    {finalPrice !== null ? finalPrice.toFixed(2) : ""}
                  </p>
                </div>
                {/* <div className="order-details">
                  <p className="order-detail">
                    Then Billed {currentPlanType}:{" "}
                  </p>
                  <p className="order-value">
                    &nbsp;&pound;{planPrice.toFixed(2)}
                  </p>
                </div> */}
              </CheckoutSummary>
            </div>
          </PaymentModalRow>
        </div>
      </Modal>
    );
  };
  public render() {
    if (this.state.navigate) {
      return <Redirect to={this.state.destination} />;
    }
    if (this.state.toLogin) {
      return <Redirect to={"/login"} />;
    }

    return (
      <Container background={this.props.isSchool ? schoolBg : parentBg}>
        <NavBar logoutParent={this.onLogout} />

        {this.renderCheckoutModal()}
        {this.renderFeedbackModal()}
        <Section
          backgroundImage="linear-gradient(45deg, rgba(36, 230, 248, .8), rgba(36, 230, 248, 0.8), rgba(172, 255, 36, 0.85))"
          justify="flex-start"
          ref={this.packagesRef}
        >
          {this.renderPackages()}
        </Section>
      </Container>
    );
  }
}

export default withServices(PrePaymentPage);



// WEBPACK FOOTER //
// ./src/pages/Onboard/PrePayment/PrePaymentPage.Component.tsx